// extracted by mini-css-extract-plugin
export default {"icon":"Service_icon__pD2HR","title":"Service_title__ksI4Q","details":"Service_details__MZoSw"};